// extracted by mini-css-extract-plugin
export default {"previewContainer":"CarouselThumbnailDragPreview-module__previewContainer--f0Z70","preview":"CarouselThumbnailDragPreview-module__preview--CkfKZ"};